export default __webpack_public_path__ + "static/media/HT-1.49648315.svg";